import { GetMaterializedApprovalsFlowsDocument } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useLazyQuery } from 'modules/core/hooks/useQuery'
import users from 'modules/core/store/collections/users'

interface PendingApprovalFlowsData {
  category: string
  totalPending: number
}

export const useEmployeePendingApprovalFlows = (ownerId: number) => {
  const access = users.get(ownerId)
  const [fetchMaterializedApprovalsFlows, { data }] = useLazyQuery(
    GetMaterializedApprovalsFlowsDocument,
    {
      variables: {
        ownerId,
        companyId: access?.attributes.company_id,
        status: 'running',
      },
    }
  )

  useEffect(() => {
    fetchMaterializedApprovalsFlows()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerId])

  const pendingApprovalFlows = data?.approvals?.materializedApprovalsFlowsConnection?.nodes || []

  const approvalFlowByResourceType = groupBy(pendingApprovalFlows, (flow) => flow.resourceType)

  return Object.keys(approvalFlowByResourceType || {}).map((resourceType) => {
    const key = resourceType as keyof typeof approvalFlowByResourceType
    return {
      totalPending: approvalFlowByResourceType[key]?.length || 0,
      category: resourceType.split('::').pop()!.toLowerCase(),
    }
  }) as PendingApprovalFlowsData[]
}
